export default "__VITE_ASSET__UQ34YaV___"